/* eslint-disable */
(function() {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    )

  angular.module('MktzapApp.Controllers')
    .controller('ReportPayrollV2TransactionController', reports)

  reports.$inject = ['$scope', '$http', 'LangService', 'NotificationService', 'ReportPayrollV2TransactionService', 'ngTableParams', 'FoundationApi']

  function reports($scope, $http, LangService, NotificationService, ReportPayrollV2TransactionService, ngTableParams, FoundationApi) {
    var vm = this
    $scope.vm = vm
    $scope.transactions = []

    vm.showFormSearch = true
    vm.showTransactionDetails = false
    vm.backButton = false
    vm.modalTransactionType = ''
    vm.modalTransactionDatetime = ''
    vm.modalTransactionDetails = ''
    vm.closeModal = closeModal

    LangService
      .getPageLabels({'page': 'menu.reports.payrollv2_transactions'})
      .$promise
      .then(function(data) {
        vm.labels = data.lang
      })

    vm.filters = {
      fromDate: moment().startOf("month").format("DD/MM/YYYY"),
      toDate: moment().endOf("month").format("DD/MM/YYYY"),
      exportMedalia: false,
    }

    vm.dateSelected = function(type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date)
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date)
      }
    }

    vm.clearSearch = function() {
      vm.filters.phone = ''
      vm.filters.cpf = ''
      vm.filters.validate_cpf_intention = ''
      vm.filters.verify_proposals_intention = ''
      vm.filters.generate_token_intention = ''
      vm.filters.generate_link_intention = ''
      vm.filters.send_history_p3_intention = ''
      vm.tableAround = ''
    }

    vm.getTransactions = function() {
      vm.tableAround = false
      vm.transactionsTable = new ngTableParams({
        page: 1,
        count: 30,
      }, {
        counts: [30, 50, 100],
        getData: function($defer, params) {
          let pagination = params.url()
          pagination = {
            page: pagination['page'],
            count: pagination['count'],
            filters: vm.filters
          }

          ReportPayrollV2TransactionService
            .paged(pagination)
            .$promise
            .then(function(response) {
              if (response.success === false) {
                NotificationService.warningHandler(response, response.message)
                return
              }

              params.total(response.result.total)
              $defer.resolve(response.result.data)
              vm.data_total = response.result.total
              vm.data_result = response.result.data.length
              vm.tableAround = true
            }).catch(function({ data }) {
              const errors = data.errors.validation
              if (errors) {
                errors.map(function(message) {
                  NotificationService.warningHandler(null, message)
                })
              } else {
                NotificationService.errorHandler(null, data.errors)
              }
            })
          }
      })
    }

    vm.colorTransactionStatus = function (transactionStatus) {
      switch (transactionStatus) {
        case null:
          return 'bg-yellow'

        case true:
          return 'bg-green'

        case false:
          return 'bg-red'

        default:
          return ''
      }
    }

    vm.downloadTransactions = function() {
      vm.filters.exportMedalia = true
      vm.filters.isSearch = false

      $http.get(apiUrl + '/reports/payrollv2-transactions-download', {
        params: {
          filters: vm.filters
        }
      })
      .then(function(retorno) {
        const filedata = retorno.data

        const success = prepareFileForDownload(filedata)

        if (!success) {
          NotificationService.warningHandler(data, $scope.labels.noRecord)
        }
      }).catch(function({ data }) {
        const errors = data.errors.validation

        if (errors) {
          errors.map(function(message) {
            NotificationService.warningHandler(null, message)
          })
        } else {
          NotificationService.errorHandler(null, data.errors)
        }
      })
    }

    function prepareFileForDownload(filedata) {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)

      let blob = new Blob([filedata], { type: 'text/csv' })

      if (blob.size <= 58) {
        return false
      }

      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: 'PayrollV2_Transactions.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }

    vm.backListing = function () {
      vm.showFormSearch = true
      vm.showTransactionDetails = false
      vm.backButton = false
      vm.informationTransaction = ''
    }

    vm.moreTransactionInformation = function (id) {
      console.log('moreTransactionInformation', id)
      vm.showFormSearch = false
      vm.showTransactionDetails = true
      vm.backButton = true

      vm.informationTransaction = vm.transactionsTable.data.find(transaction => transaction._id == id)

      vm.tableTransactionsResult = new ngTableParams({
        page: 1,
        count: 10,
      }, {
        data: vm.informationTransaction.actions.payrollv2_term.transactions
      })
    }

    vm.transactionDetails = function (transaction) {
      FoundationApi.publish('modalTransactionDetails', 'open')
      vm.modalTransactionType = vm.labels[transaction.type]
      vm.modalTransactionDatetime = transaction.datetime
      vm.modalTransactionDetails = JSON.stringify(transaction.request, null, 2)
    }

    function closeModal () {
      FoundationApi.publish('modalTransactionDetails', 'close')
    }
  }
})();
